import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../../../common/createSxStyles";

export const useSystemSecondarySupplierStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        subProcessorContainer: {
            position: "relative",
            textAlign: "center",
            padding: theme.spacing(3),
        },
    });
};
